import styled from 'styled-components';
import { Separator } from '../../separator';
export const InputSeparator = styled(Separator).attrs({ vertical: true }) `
  height: calc(100% - 6px);
`;
//# sourceMappingURL=input-separator.js.map